import { IonIcon } from '@ionic/react';
import styled from 'styled-components';

export const Icon = styled(IonIcon)<{ $color: string }>`
  --ion-color-base: ${({ $color }) =>
    $color.startsWith('--') ? `var(${$color})` : $color} !important;
  color: ${({ $color }) => ($color.startsWith('--') ? `var(${$color})` : $color)} !important;
  margin-bottom: 20px;
  width: 128px;
  height: 128px;
  padding-top: 100px;
`;
